import {throwError as observableThrowError, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {BaseService} from '../base.service';
import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Paging} from '../../models/latipay/paging.model';
import {Sorts} from '../../models/admin/sorts.model';
import {PromoCategory} from '../../models/latipay/promo-category.model';
import {Headers, Http, RequestOptions} from '@angular/http';
import {AppActivityPrizeWallet} from '../../models/latipay/app-activity-prize-wallet.model';
import {AppActivityCondition} from '../../models/latipay/app-activity-condition.model';

@Injectable()
export class AppActivityConditionService extends BaseService implements OnInit {

    constructor(public http: HttpClient,
                public httpP: Http) {
        super('app-activity-condition', http);
    }

    ngOnInit(): void {
    }

    getAllCategory(searchStr ?: string) {
        searchStr = searchStr ? searchStr : '';
        let tempPaging = new Paging({pageNumber: 1, pageSize: 1000000});
        let idSortStr = '&sort=queue,asc';
        return this.http.get(`${this.url}?${tempPaging.getPagingStr()}${this.embeddedStr + searchStr + idSortStr}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    getAllCoupons(walletId: string) {
        const str = '&f_walletId=' + walletId;
        let tempPaging = new Paging({pageNumber: 1, pageSize: 1000000});
        let idSortStr = '&sort=queue,asc';
        return this.http.get(`${this.url}?${tempPaging.getPagingStr()}${str}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }


    getAllTopicByPaging(searchCondition: string, sortOprions: Sorts, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        const sortStr = sortOprions.getSortString();
        return this.http.get(`${this.url}${sortStr}${paging.getPagingStr()}${this.embeddedStr + searchCondition}&sort=queue,asc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllByBusinessIdByPaging(searchCondition: string, businessId: number, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }

        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition}&sort=id,desc` + (businessId ? `&f_businessId=${businessId}&f_businessId_op==` : '')).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllByWalletIdsByPaging(walletIds: string[], searchCondition: string, paging: Paging) {
        const sortStr = '&sort=id,asc';
        let walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(id => {
                walletIdsStr += `&f_acceptedMerchants=${id}`;
            })
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(`${this.url}?${paging.getPagingStr()}${walletIdsStr}${sortStr}${searchCondition}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res))
        );
    }

    publishCouponById(id: string) {
        return this.http.post(`${this.url}/${id}/dispatch`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    // updatePromoCategoryList(data: PromoCategory[], token: string) {
    //     const header: Headers = new Headers();
    //     header.append('Content-Type', 'application/json');
    //     header.append('Authorization', token);
    //     const options = new RequestOptions({headers: header});
    //     return this.httpP.post(`${this.url}/${promoId}/update-link`, value, options).pipe(
    //         map((response) => response), catchError((res: any) => observableThrowError(res)));
    // }

    swapCategoryQueue(origin: string, target: string) {
        return this.http.post(`${this.url}/${origin}/${target}/swap`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    deleteWalletByCouponId(id: number) {
        return this.http.post(`${this.url}/${id}/delete-wallets`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    updatePromoCategoryList(value: any, token: string) {
        const header: Headers = new Headers();
        header.append('Content-Type', 'application/json');
        header.append('Authorization', token);
        const options = new RequestOptions({headers: header});
        return this.httpP.post(`${this.url}/update-sort`, value, options).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllCondtion(searchStr ?: string) {
        searchStr = searchStr ? searchStr : '';
        let tempPaging = new Paging({pageNumber: 1, pageSize: 1000000});
        let idSortStr = '&sort=queue,asc';
        const embed = '&embedded=prize';
        return this.http.get(`${this.url}?${tempPaging.getPagingStr()}${embed + searchStr}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    getAllSelectBusinessCondtion(prizeId: number, searchStr ?: string) {
        searchStr = searchStr ? searchStr : '';
        let tempPaging = new Paging({pageNumber: 1, pageSize: 1000000});
        let idSortStr = '&sort=queue,asc';
        const embed = '&embedded=prize';
        return this.http.get(`${this.url}/${prizeId}//get-business?${tempPaging.getPagingStr()}${embed + searchStr}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    getAllBusinessCondtion(walletId: string, searchStr ?: string) {
        searchStr = searchStr ? searchStr : '';
        let tempPaging = new Paging({pageNumber: 1, pageSize: 1000000});
        let idSortStr = '&sort=queue,asc';
        const embed = '&embedded=prize';
        return this.http.get(`${this.url}/business-condition/${walletId}?${tempPaging.getPagingStr()}${embed + searchStr}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    getAllConditionByPaging(searchCondition: string, activityId: number, paging: Paging) {
        let idSortStr = '&sort=createdOn,desc';
        if (!searchCondition) {
            searchCondition = '';
        }
        const embedStr = '&embedded=prize';
        let str = '&f_prize.activityId_op==&f_prize.activityId=' + activityId;
        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition + idSortStr + str + embedStr}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    updateStatus(id: number, enabled: number) {
        return this.http.post(`${this.url}/${id}/${enabled}/update-status`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    remove(id: number) {
        return this.http.post(`${this.url}/${id}/remove`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    addAll(id: number, activityId: number) {
        return this.http.post(`${this.url}/${id}/${activityId}/add-all`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }
    addAllOther(id: number) {
        return this.http.post(`${this.url}/${id}/add-all-latipay`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    deleteByPrizeIdAndActivityId(id: number, activityId: number) {
        return this.http.post(`${this.url}/${id}/${activityId}/delete-all`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    addWeight(prizeId: number, weight: number) {
        return this.http.post(`${this.url}/${prizeId}/${weight}/add-weight`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    reduceWeight(prizeId: number, weight: number) {
        return this.http.post(`${this.url}/${prizeId}/${weight}/reduce-weight`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }
    adjustMinAmount(prizeId: number, minAmount: number) {
        return this.http.post(`${this.url}/${prizeId}/${minAmount}/adjust-min-amount`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    addWallet(value: AppActivityCondition) {
        return this.http.post(`${this.url}`, value).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    updateWalletByList(value: any, token: string) {
        const header: Headers = new Headers();
        header.append('Content-Type', 'application/json');
        header.append('Authorization', token);
        const options = new RequestOptions({headers: header});
        return this.httpP.post(`${this.url}/update-condition`, value, options).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }
}
